'use strict';

var _ = require('lodash');
var ItemsListService = function ItemsListService() {
  /**
   *
   * @param scope
   * @returns {Array}
   */
  function mergeItems(scope) {
    var itemList = [];
    if (scope.resetSelectionEnabled) {
      itemList = _.union([{
        reset: true
      }], scope.itemList);
    } else {
      itemList = scope.itemList;
    }
    if (!_.isEmpty(scope.customizableItems)) {
      return _.union(scope.customizableItems, [{
        separator: true
      }], itemList);
    }
    return itemList;
  }
  function getVisibleLabel(item) {
    return _.isFunction(item) ? item() : item;
  }

  /**
   *
   * @param scope
   */
  function setList(scope) {
    scope.filteredItemList = mergeItems(scope);
    scope.activeIndex = -1;
    if (!isListOfStrings(scope)) {
      scope.itemMap = _.reduce(scope.filteredItemList, function (map, d) {
        var id = d[scope.idPropertyName];
        map[id] = getVisibleLabel(d[scope.labelPropertyName]);
        return map;
      }, {});
    }
  }

  /**
   *
   * @param scope
   * @param filterValue
   */
  function filterList(scope, filterValue) {
    scope.filteredItemList = mergeItems(scope);
    scope.activeIndex = -1;
    if (filterValue) {
      scope.filteredItemList = _.filter(scope.itemList, function (item) {
        return scope.itemToLabel(item).toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
      });
      if (scope.filteredItemList.length > 0) {
        scope.activeIndex = 0;
      }
    }
  }

  /**
   * Check if all items of scope.itemList are strings (or separators)
   * @param scope
   * @returns {boolean}
   */
  function isListOfStrings(scope) {
    return _.every(scope.itemList, function (item) {
      return _.isString(item) || _.has(item, 'separator');
    });
  }

  /**
   *
   * @param scope
   * @param inputValue
   * @returns {*}
   */
  function inputToValue(scope, inputValue) {
    if (scope.inputType === 'string') {
      return inputValue;
    }
    if (scope.inputType === 'number' && !isNaN(inputValue)) {
      return parseFloat(inputValue);
    }
    return null;
  }

  /**
   *
   * @param scope
   * @param ngModelCtrl
   * @param inputValue
   */
  function setEditableOption(scope, ngModelCtrl, inputValue) {
    var value,
      dropDownLabels,
      dropDownItems = {},
      obj;
    if (scope.editable) {
      value = inputToValue(scope, inputValue);
      if (value || inputValue === '' || value === 0) {
        if (isListOfStrings(scope)) {
          ngModelCtrl.$setViewValue(inputValue);
        } else {
          obj = {};
          obj[scope.labelPropertyName] = inputValue;
          ngModelCtrl.$setViewValue(obj);
        }
      }
    }
    if (scope.validate) {
      value = inputToValue(scope, inputValue);
      if (value || inputValue === '' || value === 0) {
        _.each(scope.itemList, function (item) {
          dropDownItems[scope.itemToLabel(item)] = item;
        });
        dropDownLabels = _.keys(dropDownItems);
        if (_.indexOf(dropDownLabels, value) > -1 || value === scope.placeholder || inputValue === '') {
          ngModelCtrl.$setViewValue(dropDownItems[value]);
          ngModelCtrl.$setValidity('required', true);
        } else {
          obj = {};
          value = value.toString();
          obj[scope.labelPropertyName] = value;
          ngModelCtrl.$setViewValue(obj);
          ngModelCtrl.$setValidity('required', false);
        }
      }
    }
  }
  return {
    setList: setList,
    filterList: filterList,
    isListOfStrings: isListOfStrings,
    setEditableOption: setEditableOption
  };
};
ItemsListService.$inject = [];
module.exports = ItemsListService;